import {BasePageData} from '../models/strapi/base-page-data';
import { StrapiButtonProps } from '../models/strapi/strapi-button-props';
import { StrapiHeadline } from '../models/strapi/strapi-headline';
import { StrapiMeta } from '../models/strapi/strapi-meta';
import { StrapiParagraphProps } from '../models/strapi/strapi-paragraph-props';
import { StrapiStage } from '../models/strapi/strapi-stage';
import { StrapiTextFieldProps } from '../models/strapi/strapi-text-field-props';
import { StrapiTextSectionProps } from '../models/strapi/strapi-text-section-props';
import { useLanguageDependentDataSSr } from './useLanguageDependentDataSsr.hook';

export const useInstanceDetailPage = useLanguageDependentDataSSr<UseInstanceDetailPageData>(
    'instance-detail-page'
);

export interface UseInstanceDetailPageData extends BasePageData{
    stage: StrapiStage;
    meta: StrapiMeta;
    fixedPriceHeadline: StrapiHeadline;
    resaleHeadline: StrapiHeadline;
    resaleConfirmationHeadline: StrapiHeadline;
    mintingHeadline: StrapiHeadline;
    abortResaleHeadline: StrapiHeadline;
    notAvailableHeadline: StrapiHeadline;
    ownerOptionsHeadline: StrapiHeadline;
    ownerOptionDescription: StrapiParagraphProps;
    initialDrop: StrapiParagraphProps;
    buyButton: StrapiButtonProps;
    taxRateNote: StrapiParagraphProps;
    duesNotes: StrapiParagraphProps;
    resale: StrapiParagraphProps;
    transactionFee: StrapiParagraphProps;
    buyWithEthOrFiat: StrapiParagraphProps;
    buyWithEth: StrapiParagraphProps;
    duesFixedPrice: StrapiParagraphProps;
    geoIpWarning: string;
    notAvailableMessage: StrapiParagraphProps;
    onLoginHeadline: StrapiHeadline;
    onLoginDescription: StrapiParagraphProps;
    onConnectWithWalletHeadline: StrapiHeadline;
    loginButton: StrapiButtonProps;
    registerButton: StrapiButtonProps;
    onWalletConnectDescription: StrapiParagraphProps;
    onWalletConnectButton: StrapiButtonProps;
    tokenHistoryHeadline: StrapiHeadline;
    tokenHistoryDescriptionLong: StrapiParagraphProps;
    mintingDescriptionGeneral: StrapiParagraphProps;
    walletConnectedText: StrapiParagraphProps;
    walletNotConnectedText: StrapiParagraphProps;
    createWallet: StrapiButtonProps;
    walletId: string;
    availableText: string;
    currentTransactionFees: string;
    mintNFT: StrapiButtonProps;
    mintingErrorMessage: string;
    networkErrorMessage: string;
    moreInstancesListHeadline: StrapiHeadline;
    stageMetaBoxTitleAuthor: string;
    stageMetaBoxTitlePublisher: string;
    stageMetaBoxTitleCopies: string;
    stageMetaBoxTitleRelease: string;
    stageFileDescription: string;
    sellNftDescription: StrapiParagraphProps;
    startDate: StrapiTextFieldProps;
    startTime: StrapiTextFieldProps;
    ethPrice: StrapiTextFieldProps;
    sellButton: StrapiButtonProps;
    backButton: StrapiButtonProps;
    confirmAgb: StrapiTextFieldProps;
    confirmListingPart1: string;
    confirmListingPart2: string;
    confirmListingPart3: string;
    confirmListingPart4: string;
    unlockableDownloadsHeadline: StrapiHeadline;
    unlockableFilesHeadline: StrapiHeadline;
    unlockableHiresCoverHeadline: StrapiHeadline;
    instanceCoverHeadline: StrapiHeadline;
    loginDialogHeader: StrapiTextSectionProps;
    cancelSaleDescription: StrapiParagraphProps;
    onSaleForPrice: StrapiParagraphProps;
    confimCancelSale: StrapiParagraphProps;
    cancelSaleButton: StrapiButtonProps;
    owner:string;
    correctAccountWrongWalletPrompt: StrapiParagraphProps;
    cancelResaleError: string;
    mintingError: string;
    currentlyMinting: StrapiParagraphProps;
    cannotSellCreatoken: StrapiParagraphProps;
    listingSuccess: string;
    listingError: string;
    retrieveUnlockables: StrapiButtonProps;
    cannotCancelSaleDescription: StrapiParagraphProps;
    breadcrumbHome: string;
    breadcrumbDigitalOriginals: string;
}
